export default __webpack_public_path__ + "static/media/USC.3c5bbcbc.png";